import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import appSyncConfig from "./AppSync";
import AWSAppSyncClient from "aws-appsync";
import { Rehydrated } from "aws-appsync-react";
import { AUTH_TYPE } from "aws-appsync/lib/link/auth-link";
import Amplify, { Auth } from 'aws-amplify';
import aws_exports from './aws-exports';

// Layout
import Layout from './Layout/MainLayout';
import Public  from './Layout/PublicLayout';

// List Views
import Signin from './Components/Signin';
import Signout from './Components/Signout';
import PrivateRoute from './Components/PrivateRoute';
import PublicRoute from './Components/PublicRoute';
import Dashboard from './Components/Dashboard';

//import TherapistsList from './Components/TherapistsList';
//import TherapistForm from './Components/TherapistForm';

import PatientForm from './Components/PatientForm';
import PatientsList from './Components/PatientsList';

import AnalysisForm from './Components/AnalysisForm';
import AnalysisView from './Components/AnalysisView';
import AnalysisPDF from './Components/AnalysisPDF';
import AnalysisList from './Components/AnalysisList';

import Setting from './Components/Setting';

import UserProfile from './Components/UserProfile';
import UserSignup from './Components/UserSignup';
import UserChangePass from './Components/UserChangePass';
import UserForgotPwd from './Components/UserForgotPwd';
import UserResetPass from './Components/UserResetPass';
import UserCompleteNewPass from './Components/UserCompleteNewPass';

//import CheckoutForm from './Components/CheckoutForm';
//import CheckoutHistory from './Components/CheckoutHistory';

Amplify.configure(aws_exports);

const App = () => (
  <Router>
    <div>
        <Switch>
          <PrivateRoute exact path="/" component={Dashboard} layout={Layout} />
          {/*
          <PrivateRoute path="/therapists/list" component={TherapistsList} layout={Layout} />
          <PrivateRoute path="/therapists/create" component={TherapistForm} layout={Layout} />
          <PrivateRoute path="/therapists/:id/" component={TherapistForm} layout={Layout} />
          */}
          <PrivateRoute path="/patients/list" component={PatientsList} layout={Layout} />
          <PrivateRoute path="/patients/create" component={PatientForm} layout={Layout} />
          <PrivateRoute path="/patients/:id/" component={PatientForm} layout={Layout} />

          <PrivateRoute path="/assessments/create/:assessment_id" component={AnalysisForm} layout={Layout} />
          <PrivateRoute path="/assessments/view/:assessment_id/:id/" component={AnalysisView} layout={Layout} />
          <PublicRoute path="/assessments/export/:assessment_id/:id/" component={AnalysisPDF} layout={Public} />
          <PrivateRoute path="/assessments/list/:assessment_id" component={AnalysisList} layout={Layout} />
          <PrivateRoute path="/assessments/:assessment_id/:id/" component={AnalysisForm} layout={Layout} />

          <PrivateRoute path="/user/profile/" component={UserProfile} layout={Layout} />
          <PrivateRoute path="/user/change_pwd/" component={UserChangePass} layout={Layout} />
          <PrivateRoute path="/setting" component={Setting} layout={Layout} />
          {/*
          <PrivateRoute path="/payment/checkout" component={CheckoutForm} layout={Layout} />
          <PrivateRoute path="/payment/history" component={CheckoutHistory} layout={Layout} />
          */}
        </Switch>
        <Switch>
          <PublicRoute path="/user/signin" component={Signin} layout={Public} />
          <PublicRoute path="/user/signout" component={Signout} layout={Public} />
          <PublicRoute path="/user/forgot_pwd" component={UserForgotPwd} layout={Public} />
          <PublicRoute path="/user/reset_pwd" component={UserResetPass} layout={Public} />
          <PublicRoute path="/user/new_pwd" component={UserCompleteNewPass} layout={Public} />
          <PublicRoute path="/user/signup" component={UserSignup} layout={Public} />
        </Switch>
    </div>
  </Router>
);

export const client = new AWSAppSyncClient({
  url: appSyncConfig.graphqlEndpoint,
  region: appSyncConfig.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
  },
  disableOffline: true
});

const WithProvider = () => (
  <ApolloProvider client={client}>
    <Rehydrated>
      <App />
    </Rehydrated>
  </ApolloProvider>
);

export default WithProvider;
